/* eslint-disable @typescript-eslint/no-restricted-imports */
import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { RootState } from '../types';

const useStoreSelector: TypedUseSelectorHook<RootState> = useSelector;

export default useStoreSelector;
